var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"sidebar-demo"}},[_c('sidebar-default'),_c('sidebar-parent'),_c('sidebar-static'),_c('sidebar-group-collapsed'),_c('sidebar-right'),_c('sidebar-reduce-expand'),_c('sidebar-custom')],1)}
var staticRenderFns = []

export { render, staticRenderFns }